import { render, staticRenderFns } from "./OptionsPreview.vue?vue&type=template&id=3ffc9bf0&scoped=true"
import script from "./OptionsPreview.vue?vue&type=script&lang=js"
export * from "./OptionsPreview.vue?vue&type=script&lang=js"
import style0 from "./OptionsPreview.vue?vue&type=style&index=0&id=3ffc9bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc9bf0",
  null
  
)

export default component.exports